import React from "react";
import CountrySelect from "./CountrySelect";
import { Box, FormControl, FormLabel, TextField } from "@mui/material";
import { useSelector } from "react-redux";

const PhoneNumberInput = ({
  value = "",
  dialCodeValue = "",
  label = "",
  handleBlur = () => {},
  handleChange = () => {},
  onBlur = () => {},
  onChange = () => {},
  error = "",
  textfieldProps = {},
  disabled = false,
  min=8,
  placeholder,
  ...props
}) => {

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Settings || {},
  }));

  return (
    <FormControl fullWidth {...props}>
      <FormLabel color="secondary" required label>
        {/* {label} */}
        {label ? label : Translation?.PhoneNumber}
      </FormLabel>
      <Box display={"flex"} gap="10px">
        <CountrySelect onBlur={onBlur} onChange={onChange} value={dialCodeValue} textfieldProps={textfieldProps} type="code" disabled={disabled} />
        <TextField
          fullWidth
          error={Boolean(error)}
          helperText={error}
          onChange={(e) => {
            const onlyNumbers = e.target.value.replace(/\D/g, "");
            e.target.value = onlyNumbers.slice(0, min)
            handleChange(e)
          }}
          onBlur={handleBlur}
          name="Mobile"
          size="small"
          value={value}
          disabled={disabled}
          placeholder={placeholder || Translation?.EnterYourContactNumber}
          // type="tel"
          type="text"
          min={min}
          {...textfieldProps}
          sx = {{ direction: "ltr !important" }}
          // sx={(theme) => ({
          //   direction: theme.direction === "rtl" ? "rtl !important" : "ltr !important",   
          //   // textAlign: theme.direction === "rtl" ? "right" : "left",
          //   // unicodeBidi: "plaintext", 
          // })}
        />
      </Box>
    </FormControl>
  );
};

export default React.memo(PhoneNumberInput);
